<template>
    <div>
        <Row :gutter="16">
            <Card>
                <p slot="title">{{t.routerName}}</p>
                <Row>
                    <Col>
                        <Form :model="formItem" :rules="ruleValidate" :label-width="85" label-position="right"
                              ref="form">
                            <FormItem :label="t.journal.title" prop="title">
                                <Input v-model="formItem.title" :maxlength="30"
                                       :placeholder="msgUtil.placeholderRequired(t.journal.title)"></Input>
                            </FormItem>
                            <FormItem :label="t.journal.type" prop="type">
                                <Select v-model="formItem.type"
                                        :placeholder="msgUtil.placeholderSelected(t.journal.type)">
                                    <Option value="0">{{t.journal.monthJournal}}</Option>
                                    <Option value="1">{{t.journal.dayJournal}}</Option>
                                </Select>
                            </FormItem>
                            <Form-item :label="t.journal.releaseDate" prop="releaseDate" v-if="formItem.type==='0'">
                                <DatePicker type="month" format="yyyy/MM"
                                            v-model="formItem.releaseDate" style="width: 100% !important"
                                            :editable="false"
                                            @on-change="handleChangeReleaseDate"
                                            :placeholder="msgUtil.placeholderSelected(t.journal.releaseDate)">
                                </DatePicker>
                            </Form-item>
                            <Form-item :label="t.journal.releaseDate" prop="releaseDate" v-if="formItem.type==='1'">
                                <DatePicker type="date" format="yyyy/MM/dd"
                                            v-model="formItem.releaseDate" style="width: 100% !important"
                                            :editable="false"
                                            @on-change="handleChangeReleaseDate"
                                            :placeholder="msgUtil.placeholderSelected(t.journal.releaseDate)">
                                </DatePicker>
                            </Form-item>
                            <FormItem :label="t.journal.status" prop="status">
                                <i-switch v-model="formItem.status" size="large" true-value="1" false-value="0">
                                    <span slot="open">{{t.journal.open}}</span>
                                    <span slot="close">{{t.journal.close}}</span>
                                </i-switch>
                            </FormItem>
                            <FormItem :label="t.journal.body" prop="body">
                                <Input v-model="formItem.body"
                                       :autosize="{minRows: 6}"
                                       :placeholder="msgUtil.placeholderRequired(t.journal.body)"
                                       type="textarea"></Input>
                            </FormItem>
                            <FormItem :label="t.journal.description" prop="description">
                                <tinymce id="id1" v-model="formItem.description" :toolbar1="toolbar1"
                                         :other_options="other_options"></tinymce>
                            </FormItem>
                            <FormItem>
                                <Button type="primary" :loading="loading" @click="handleSubmit()">
                                    {{msgUtil.message.action.submit}}
                                </Button>
                                <Button @click="handleReset()" style="margin-left: 8px">
                                    {{msgUtil.message.action.reset}}
                                </Button>
                            </FormItem>
                        </Form>
                    </Col>
                </Row>
            </Card>
        </Row>
    </div>
</template>
<script>
import BaseUrl from '_conf/url';
import axios from 'axios';
import { edit, getJournalInfo } from '@/api/journal';

export default {
    name: 'content_journal_edit',
    data() {
        const t = this.$_t();
        const msgUtil = this.$msgUtil;
        return {
            self: this,
            t: t,
            msgUtil: msgUtil,
            formItemBk: {},
            formItem: {
                title: '',
                type: '0',
                releaseDate: null,
                status: '1',
                body: '',
                description: '',
            },
            ruleValidate: {
                title: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.journal.title),
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        max: 100,
                        message: msgUtil.errorMaxLengthFullWidth(t.journal.title, 100),
                        trigger: 'blur',
                    },
                ],
                type: [
                    {
                        required: true,
                        message: msgUtil.errorSelected(t.journal.type),
                        trigger: 'blur',
                    },
                ],
                releaseDate: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.journal.releaseDate),
                        trigger: 'blur',
                    },
                ],
                body: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.journal.body),
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        max: 500,
                        message: msgUtil.errorMaxLengthFullWidth(t.journal.body, 500),
                        trigger: 'blur',
                    },
                ],
                description: [
                    {
                        type: 'string',
                        max: 30000,
                        message: msgUtil.errorMaxLengthFullWidth(t.journal.description, 30000),
                        trigger: 'blur',
                    },
                ],
            },
            loading: false,
            toolbar1:
                'newnote print preview code | undo redo | insert | styleselect | fontsizeselect | fontselect | forecolor backcolor bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image emoticons media codesample',
            other_options: {
                height: 400,
                menubar: false,
                plugins: 'image code print preview',
                images_upload_handler: function(blobInfo, success, failure) {
                    let param = new FormData(); //创建form对象
                    param.append('image', blobInfo.blob(), blobInfo.filename()); //通过append向form对象添加数据
                    axios
                        .post(BaseUrl.dataUrl + '/image/scale/', param)
                        .then(response => success(BaseUrl.Url + response.data.url));
                },
            },
        };
    },
    beforeCreate() {
        import('tinymce-i18n/langs/ja');
    },
    methods: {
        async handleSubmit() {
            this.loading = true;
            this.$Loading.start();
            if (this.formItem.type === '0' && this.formItem.releaseDate instanceof Date) {
                this.formItem.releaseDate = this.formItem.releaseDate.format('yyyy/MM');
            }
            if (await this.$refs['form'].validate()) {
                let journalDto = {};
                journalDto.title = this.formItem.title;
                journalDto.type = this.formItem.type;
                journalDto.status = this.formItem.status;
                journalDto.body = this.formItem.body;
                journalDto.description = this.formItem.description;
                let dataArr = this.formItem.releaseDate.split('/');
                this.formItem.releaseYear = dataArr[0];
                this.formItem.releaseMonth = dataArr[1];
                if (this.formItem.type == '1' && dataArr.length == 3) {
                    this.formItem.releaseDay = dataArr[2];
                } else {
                    this.formItem.releaseDay = null;
                }
                journalDto.releaseYear = this.formItem.releaseYear;
                journalDto.releaseMonth = this.formItem.releaseMonth;
                journalDto.releaseDay = this.formItem.releaseDay;

                await edit(this.$route.params.id, journalDto);
                Object.assign(this.formItemBk, this.formItem);
                this.$Loading.finish();
                this.$Message.success(this.msgUtil.message.action.updateSuccess);
            } else {
                this.$Loading.error();
                this.$Message.error(this.msgUtil.message.action.updateFail);
            }
            this.loading = false;
        },
        handleReset() {
            this.$refs.form.resetFields();
            Object.assign(this.formItem, this.formItemBk);
            this.loading = false;
        },
        handleChangeReleaseDate(releaseDate) {
            this.formItem.releaseDate = releaseDate;
        },
        async init() {
            const journalsInfo = await getJournalInfo(this.$route.params.id);
            if (journalsInfo.journal != null) {
                this.formItem = journalsInfo.journal;
                let newDate = this.formItem.releaseYear + '/' + this.formItem.releaseMonth;
                if (this.formItem.type === '1') {
                    newDate = newDate + this.formItem.releaseYear;
                }
                this.formItem.releaseDate = newDate;
                Object.assign(this.formItemBk, this.formItem);
            }
        },
    },
    async mounted() {
        await this.init();
    },
};
</script>
<style lang="less" scoped>
.user-avatar {
    display: inline-block;
    text-align: center;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
    line-height: 0px;
    margin-right: 4px;
    cursor: pointer;
    img {
        width: 60px;
        height: 60px;
    }
    &:hover,
    &:focus {
        background-color: rgba(107, 107, 107, 0.178);
    }
}

.upload {
    display: inline-block;
    width: 100px;
    line-height: 100px;
}

.upload_img {
    width: 100%;
    height: 240px;
}
</style>
<style lang="less" src="@/assets/less/i-switch.less" scoped>
</style>
